import { Moon, Sun, Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="hover:bg-surface-hover">
        <Sun size={20} className="text-foreground" />
      </Button>
    );
  }

  const cycleTheme = () => {
    if (theme === 'light') setTheme('dark');
    else if (theme === 'dark') setTheme('system');
    else setTheme('light');
  };

  const getIcon = () => {
    if (theme === 'dark') return <Moon size={20} className="text-foreground" />;
    if (theme === 'light') return <Sun size={20} className="text-foreground" />;
    return <Monitor size={20} className="text-foreground" />;
  };

  const getLabel = () => {
    if (theme === 'dark') return 'dark';
    if (theme === 'light') return 'light';
    return 'system';
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycleTheme}
      className="hover:bg-surface-hover"
      aria-label={`Current theme: ${getLabel()}. Click to change.`}
    >
      {getIcon()}
    </Button>
  );
}
